import * as React from "react"
import { Popover, Button } from "@walmart-web/livingdesign-components"

import "./index.scss"

export type dropdownOptionType = {
	id: string
	name: string
}
interface DropdownProps {
	buttonName: string
	buttonIcon?: React.ReactNode
	onSelectFunction: Function
	dropdownOptions: Array<dropdownOptionType>
	disabled?: boolean
	buttonIconRight?: React.ReactNode
}

const Dropdown: React.FC<DropdownProps> = ({
	buttonName,
	buttonIcon,
	onSelectFunction,
	dropdownOptions,
	disabled = false,
	buttonIconRight,
}) => {
	const buttonRef = React.useRef<HTMLButtonElement>(null)
	const [isOpen, setIsOpen] = React.useState<boolean>(false)

	const handleClickOnOption = (optionId: string) => {
		onSelectFunction(optionId)
		setIsOpen(false)
	}

	const hasOptions: boolean = dropdownOptions.length != 0
	const handleOpen = () => {
		if (hasOptions) setIsOpen(!isOpen)
	}

	return (
		<Popover
			UNSAFE_className="dropdown-container"
			content={
				<div className="selector-dropdown-options">
					{dropdownOptions.map(({ id, name }) => {
						return (
							<button
								key={id}
								className="dropdown-option"
								onClick={() => handleClickOnOption(id)}
							>
								{name}
							</button>
						)
					})}
				</div>
			}
			onClose={() => setIsOpen(false)}
			isOpen={isOpen}
			triggerRef={buttonRef}
		>
			<Button
				ref={buttonRef}
				variant="primary"
				UNSAFE_className="dropdown-button"
				leading={buttonIcon}
				onClick={handleOpen}
				disabled={disabled || !hasOptions}
				trailing={buttonIconRight}
			>
				{buttonName}
			</Button>
		</Popover>
	)
}
export default Dropdown
